export default "__VITE_ASSET__28c1905d__"